<template>

  <div>

    <div class="slider" :key="thisslide.bild.ID" v-if="thisslide.bild"
         :style="{backgroundImage: getBackground(),height:height+'vh'}" :class="{'content':content}">
      <div class='slidernavi' v-if="slider.length>1" :style="{opacity:getOpacity()}" :class="{filter:filter}">
        <div @click="getPrevSlide()" style="cursor: pointer;padding-top: 2px;">
          <svgicon class='stroketwo' name="ICON_chevron-left" :fill="false" height="30"></svgicon>
        </div>
        <div style="" class="counter">
          <div class="number up"> {{ activeslide + 1 }}</div>
          <svgicon class='stroketwo' name="ICON_slash" height="35" :fill="false"></svgicon>
          <div class="number down"> {{ slider.length }}</div>
        </div>
        <div @click="getNextSlide()" style="cursor: pointer;padding-top: 2px;">
          <svgicon class='svg-down stroketwo' name="ICON_chevron-left" :fill="false" height="30"></svgicon>
        </div>
      </div>
      <div class="weiter" v-else-if="!content&&!filter"
           :style="{opacity:getOpacity()}">
        <div>
          Weiter
          <img src="@/assets/weiter.svg" alt="">
        </div>
      </div>

      <div class="row whole " style="height: 100%;" v-if="!content">
        <div class="col-8 col-sm-4 biglogo" style="">
          <img src="../../assets/2perform_Logo_weiss_RGB.png" alt="" style="width: 50%;"
               class="d-none d-md-inline"
               v-if="$route.name==='Start'">
          <img src="../../assets/2perform_Logo_weiss_RGB.png" alt="" style="width: 50%;" class="d-inline d-md-none"
               v-if="$route.name==='Start'">
          <br>
          <h1 v-html="thisslide.text" :class="{'center':$route.name==='Start'}">{{}}</h1>
        </div>
        <div class="col-4"></div>
      </div>
      <div class="row whole justify-content-between" v-else>
        <Whitebox :whitebox="content" class="col-8 col-lg-3 xl-25" :overview="overview"
                  :class="{mobileoff:mode==='calendar' || mode==='form'}"></Whitebox>

        <!--Einzelkurs-->
        <div class="col-1" v-if="$route.name==='Kurs'&&mode==='calendar'"></div>
        <Calendar class="col-8 col-lg-6" v-if="$route.name==='Kurs'&&mode==='calendar'"
                  :content="content"></Calendar>
        <div class="col-1" v-if="$route.name==='Kurs'&&mode==='calendar'"></div>
        <Kursinfo class="col-8 col-lg-3 xl-25 kursinfo" :content="content"
                  v-if="$route.name==='Kurs'&&mode==='info'"
        ></Kursinfo>
       <Buchungsinfo v-if="$route.name==='Therapie' && content.acf.buchungslink"></Buchungsinfo>
        <div class="col-1" v-if="$route.name==='Kurs'&&mode==='form'"></div>
        <Kursform :content="content" class="col-8 col-lg-6"
                  v-if="$route.name==='Kurs'&&mode==='form'"></Kursform>
        <div class="col-1" v-if="$route.name==='Kurs'&&mode==='form'"></div>
        <!--Alle Kurse-->

        <Calendar class="col-8 col-lg-5 cal" v-if="calendar==='all'" :content="content" :key="calendar"
                  :slide="changeSlide"
                  :kurse="kurse"></Calendar>

      </div>
    </div>
    <div v-else style="height: 50px;"></div>
  </div>
  <!--</transition-group>-->
</template>

<script>
import store from '@/store';


export default {
  store,
  name: 'Slider',
  props: ['slider', 'content', 'overview', 'height', 'calendar', 'filter'],
  data() {
    return {
      activeslide: 0,
      forward: true,
      changeSlide: false
    }
  },

  methods: {
    getImg: function () {
      return this.slider[this.activeslide].bild.url
    },
    getNextSlide() {
      this.forward = true;
      this.activeslide + 1 < this.slider.length ? this.activeslide++ : this.activeslide = 0
    },
    getPrevSlide() {
      this.forward = false;
      this.activeslide === 0 ? this.activeslide = this.slider.length - 1 : this.activeslide--;
    },
    getBackground() {
      if (this.slider) {
        let bgurl = this.slider[this.activeslide].bild.url;
        return "url('" + bgurl + "')";
      }
    },
    getOpacity() {
      if (this.scrollPosition > 200) return 0;
      else return 1 - (this.scrollPosition / 200);
    }
  },
  watch: {
    slider() {
      this.activeslide = 0;
    },
    openCalendar() {
      if (this.openCalendar) store.commit('setKursmode', 'calendar')
    },
    content() {
      store.commit('setSelectedKurs', 0)
      store.commit('setKursmode', 'info')
    },
    activeslide() {
      this.changeSlide = true
    }

  },
  computed: {
    page() {
      return store.state.page
    },
    thisslide: function () {
      if (this.slider && this.slider.length > 0) return this.slider[this.activeslide];
      else return {};
    },
    prevslide() {
      return this.activeslide > 0 ? this.slider[this.activeslide - 1] : this.slider[this.slider.length - 1];
    },
    nextslide() {
      return this.activeslide + 1 < this.slider.length ? this.slider[this.activeslide + 1] : this.slider[0];
    },
    kurse() {
      return store.state.kurse;
    },
    mode() {
      return store.state.kursmode;
    }
  },
  components: {

    Whitebox: () => import('@/components/parts/Whitebox'),
    Buchungsinfo: () => import('@/components/parts/Buchungsinfo'),
    Kursinfo: () => import('@/components/parts/Kursinfo'),
    Kursform: () => import('@/components/parts/Kursform'),
    Calendar: () => import('@/components/parts/Calendar'),
  },
}
</script>

<style lang="scss" type="text/scss" scoped>

.kalender  {
  .slider  {
    height: auto;
  }
}
.slider {
  min-height: 600px;
  height: 100vh;

  .biglogo {
    align-self: center;
    @include tablet {
      align-self: start;
      @include mobile {

        margin-top: 5%;
      }
    }
  }

  &:before {
    @include mobile {
      display: none;
    }
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 50%;
    background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0));
  }

  @include tablet {
    max-height: 70vh;
    min-height: 300px;
    padding-top: 80px;
    height: auto !important;
    &.content {
      max-height: none;
      background-size: 100% auto;
      background-position: top;
      background-repeat: no-repeat;
    }
  }
  @include mobile {
    max-height: 60vh;
    padding-top: 10px;
  }

  h1 {
    color: #fff;
    text-transform: unset;
    text-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15), 0px 3px 5px rgba(0, 0, 0, 0.15);
    font-size: 36px;
    line-height: 1.2em;
    width: 80%;
    margin-left: 10%;
    text-align: left;
    @include tablet {
      text-shadow: 2px 1px rgba(#000, 0.3);
      font-size: 28px;
    }

    &.center {
      text-align: center;
    }
  }

  background-image: url('../../assets/bg.jpg');
  background-size: cover;
  background-position: center;
  position: relative;

  .weiter, .slidernavi {
    position: absolute;
    left: calc(50% - 30px);
    text-transform: uppercase;
    width: 60px;
    bottom: 0;
    color: #fff;
    transition: all 0.5s ease-out;
    transform-origin: bottom;
    @include tablet {
      display: none;
    }
  }

  .slidernavi {
    &.filter {
      bottom: 100px;
    }

    z-index: 100;
    width: 150px;
    left: calc(50% - 75px);
    justify-content: space-between;
    display: flex;
    height: 50px;
    font-size: 20px;
  }

  .whitebox {
    &.xl-25 {
      @include desktop {

        flex: 0 0 30%;
      }
    }

    position: relative;
    margin-top: calc(120px);
    /*margin-bottom: calc(100px );*/
    max-height: calc(100% - 240px);
    text-align: left;
    background-color: transparent;

    &.cal {
      overflow: auto;

    }

    overflow: hidden;

    &.mobileoff {
      display: none !important;
      @include tablet {
        display: inline-flex !important;
      }
    }

    @include tablet {
      margin-top: 20px;
      &:first-child {

        margin-top: 40%;
      }
      &.cal {
        margin-top: 10px;
      }
      overflow: auto;
      max-height: none;
      width: 80%;
      flex: 0 0 100%;
      margin-bottom: 10px;

      padding-left: 15px;
      padding-right: 15px;
      /*width: calc(100% - 30px);*/
    }
  }

  .kursinfo {
    text-align: left;
    display: flex;
    flex-direction: column;

  }
}

.number {
  font-size: 16px;
  transform: translate3d(7px, -3px, 0);

  &.down {
    transform: translate3d(-5px, 15px, 0);
  }
}

.counter {
  height: 35px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

svg {
  &.shadow {

    /* Use -webkit- only if supporting: Chrome < 54, iOS < 9.3, Android < 4.4.4 */
    -webkit-filter: drop-shadow(-5px -5px 5px #000);
    filter: drop-shadow(-5px -5px 5px #000);
  }

  &.stroketwo {
    stroke-width: 2px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/parts/Slider.vue